import { hasSubdivisionTaxError, hasZipCodeTaxError } from './calculationError.utils';
import { getFastFlowRedirectionReason } from './bi.util';
import { FastFlowRedirectionReason } from './consts';
export async function shouldNavigateToFastFlowCheckout(_ref) {
  let {
    lineItems,
    expressCheckoutSettings,
    checkoutService,
    isMemberLoggedIn,
    biService,
    checkoutId,
    purchaseFlowId
  } = _ref;
  const reasonsToNavigateToFastFlow = await getReasonsToNavigateToFastFlow({
    lineItems,
    expressCheckoutSettings,
    checkoutService,
    isMemberLoggedIn
  });
  const shouldNavigateToFastFlow = reasonsToNavigateToFastFlow.length > 0;
  if (shouldNavigateToFastFlow) {
    biService.reportNavigateToFastFlowCheckout({
      checkoutId,
      purchaseFlowId,
      reason: reasonsToNavigateToFastFlow.join()
    });
  }
  return shouldNavigateToFastFlow;
}
export async function getReasonsToNavigateToFastFlow(_ref2) {
  let {
    lineItems,
    expressCheckoutSettings,
    checkoutService,
    isMemberLoggedIn
  } = _ref2;
  const getHasCustomField = async () => {
    const [hasRequiredDataExtendedFields, hasRequiredAdditionalInfoField] = await Promise.all([checkoutService.doesFormHaveRequiredDataExtendedFields(), checkoutService.doesFormHaveRequiredAdditionalInfoField()]);
    return hasRequiredDataExtendedFields || hasRequiredAdditionalInfoField;
  };
  const hasTermsAndConditions = Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.hasPolicies);
  const hasLineItemPolicies = Boolean((lineItems == null ? void 0 : lineItems.some(lineItem => lineItem.hasPolicies)) && Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.requirePolicyAgreement));
  const hasCustomField = await getHasCustomField();
  const hasMemberOnlyCheckout = Boolean(!isMemberLoggedIn && (lineItems == null ? void 0 : lineItems.some(lineItem => lineItem.membersOnly)));
  return [...(hasLineItemPolicies ? [FastFlowRedirectionReason.hasLineItemPolicies] : []), ...(hasCustomField ? [FastFlowRedirectionReason.hasCustomField] : []), ...(hasMemberOnlyCheckout ? [FastFlowRedirectionReason.hasMemberOnlyCheckout] : []), ...(hasTermsAndConditions ? [FastFlowRedirectionReason.hasTermsAndConditions] : [])];
}
export async function shouldNavigateToFastFlowCheckoutV1(_ref3) {
  var _expressModel$lineIte, _expressModel$payNow, _expressModel$lineIte2;
  let {
    expressModel,
    prevTotalAmount,
    expressCheckoutSettings,
    checkoutService,
    biService,
    isMemberLoggedIn,
    shouldRedirectToCollectShipping,
    hasShippingZipCodeError,
    hasShippingSubdivisionError
  } = _ref3;
  // eslint-disable-next-line sonarjs/no-identical-functions
  const getHasCustomField = async () => {
    const [hasRequiredDataExtendedFields, hasRequiredAdditionalInfoField] = await Promise.all([checkoutService.doesFormHaveRequiredDataExtendedFields(), checkoutService.doesFormHaveRequiredAdditionalInfoField()]);
    return hasRequiredDataExtendedFields || hasRequiredAdditionalInfoField;
  };
  const hasTermsAndConditions = Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.hasPolicies);
  const hasLineItemPolicies = Boolean(((_expressModel$lineIte = expressModel.lineItems) == null ? void 0 : _expressModel$lineIte.some(lineItem => lineItem.hasPolicies)) && Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.requirePolicyAgreement));
  const hasCustomField = await getHasCustomField();
  const hasTaxZipCodeError = hasZipCodeTaxError(expressModel);
  const hasTaxSubdivisionError = hasSubdivisionTaxError(expressModel);
  const hasTotalAmountMismatchWithLatestSeen = prevTotalAmount !== ((_expressModel$payNow = expressModel.payNow) == null ? void 0 : _expressModel$payNow.amount);
  const hasMemberOnlyCheckout = Boolean(!isMemberLoggedIn && ((_expressModel$lineIte2 = expressModel.lineItems) == null ? void 0 : _expressModel$lineIte2.some(lineItem => lineItem.membersOnly)));
  const shouldNavigateToFastFlow = shouldRedirectToCollectShipping || hasTermsAndConditions || hasCustomField || hasTaxZipCodeError || hasTaxSubdivisionError || hasShippingZipCodeError || hasShippingSubdivisionError || hasTotalAmountMismatchWithLatestSeen || hasLineItemPolicies || expressModel.hasViolations || hasMemberOnlyCheckout;
  if (shouldNavigateToFastFlow) {
    biService.reportNavigateToFastFlowCheckout({
      checkoutId: expressModel.id,
      cartId: expressModel.cartId ?? undefined,
      purchaseFlowId: expressModel.purchaseFlowId ?? undefined,
      reason: getFastFlowRedirectionReason({
        shouldChooseShippingMethod: shouldRedirectToCollectShipping,
        hasTermsAndConditions: Boolean(hasTermsAndConditions),
        hasCustomField: Boolean(hasCustomField),
        hasTaxZipCodeError,
        hasTaxSubdivisionError,
        hasShippingZipCodeError,
        hasShippingSubdivisionError,
        hasTotalAmountMismatchWithLatestSeen,
        hasViolations: Boolean(expressModel.hasViolations),
        hasLineItemPolicies: Boolean(hasLineItemPolicies),
        hasMemberOnlyCheckout
      })
    });
  }
  return shouldNavigateToFastFlow;
}
//# sourceMappingURL=shouldNavigateToFastFlow.js.map